module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#photostory",
      toString: function () {
        return this.url;
      }
    }